import {
  GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_COLOR_SURFACE_NEUTRAL_500_DARK,
  SYS_FONT_SIZES_RELATIVE_75,
  SYS_SIZE_FIXED_700,
  SYS_SIZE_FIXED_900,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-common';
import {
  SYS_COLOR_CANVAS_200_LIGHT,
  SYS_COLOR_CANVAS_200_DARK,
} from '@oneaudi/unified-web-alpha-common';
import { CustomTheme } from '../@types/theme';
/*
  Define  color tokens.
  (preferably use "only" tokens from @oneaudi/unified-web-common)
*/

export const xsBreakPoint = parseInt(SYS_BREAKPOINT_XS, 10);
export const smBreakPoint = parseInt(SYS_BREAKPOINT_SM, 10);
export const mdBreakPoint = parseInt(SYS_BREAKPOINT_MD, 10);
export const lgBreakPoint = parseInt(SYS_BREAKPOINT_LG, 10);
export const xlBreakPoint = parseInt(SYS_BREAKPOINT_XL, 10);
export const xxlBreakPoint = parseInt(SYS_BREAKPOINT_2_XL, 10);

const colorsLight = {
  mainContainer: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT
    : SYS_COLOR_CANVAS_200_LIGHT,
  divider: SYS_COLOR_CANVAS_200_LIGHT,
};
const colorsDark = {
  mainContainer: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_DARK
    : SYS_COLOR_CANVAS_200_DARK,
  divider: process.env.IS_LEGACY ? SYS_COLOR_SURFACE_NEUTRAL_500_DARK : SYS_COLOR_CANVAS_200_DARK,
};

const fonts = {
  numberBaseSize: SYS_FONT_SIZES_RELATIVE_75,
  numberSmall: SYS_SIZE_FIXED_700,
  numberLarge: SYS_SIZE_FIXED_900,
};

const spacing = {
  fixed300: SYS_SPACE_FIXED_300,
};

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
  breakpoints,
  fonts,
  spacing,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
  breakpoints,
  fonts,
  spacing,
};
